"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Dialog_1 = require("office-ui-fabric-react/lib/Dialog");
var Utilities_1 = require("office-ui-fabric-react/lib/Utilities");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var ReactDOM = require("react-dom");
var styles = require('./OptionConfirmationDialog.scss');
/**
 * A Dialog to show three options: save your current changes, discard them, or go back and edit them.
 * This is implemented rather than using owa-confirm-dialog because that system doesn't support three options,
 * and would add unneeded complexity to that package for a one-off scenario.
 * Additionally, this may end up styled differently in the future, with stacked full-width buttons, rather than
 * using the default Dialog styling of a row of footer buttons.
 */
var OptionConfirmationDialog = /** @class */ (function (_super) {
    tslib_1.__extends(OptionConfirmationDialog, _super);
    function OptionConfirmationDialog(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isShown: false,
        };
        return _this;
    }
    OptionConfirmationDialog.prototype.componentDidMount = function () {
        this.setState({
            isShown: true,
        });
    };
    OptionConfirmationDialog.prototype.render = function () {
        var _this = this;
        return (React.createElement(Dialog_1.Dialog, { isOpen: this.state.isShown, type: Dialog_1.DialogType.normal, onDismiss: this.onDismiss, onDismissed: this.onDismissed, className: styles.dialog, title: owa_options_strings_1.default.optionsConfirmationDialog_title, subText: owa_options_strings_1.default.optionsConfirmationDialog_subtitle },
            React.createElement(Dialog_1.DialogFooter, null,
                React.createElement(Button_1.PrimaryButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_save, onClick: this.onSave, disabled: this.props.shouldDisableSaveButton }),
                React.createElement(Button_1.DefaultButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_discard, onClick: this.onDiscard }),
                React.createElement(Button_1.DefaultButton, { className: styles.footerButton, text: owa_options_strings_1.default.optionsConfirmationDialog_cancel, onClick: function () { return _this.setState({ isShown: false }); } }))));
    };
    OptionConfirmationDialog.prototype.onSave = function () {
        this.onDismiss();
        this.props.onSave();
    };
    OptionConfirmationDialog.prototype.onDiscard = function () {
        this.onDismiss();
        this.props.onDiscard();
    };
    OptionConfirmationDialog.prototype.onDismiss = function () {
        this.setState({
            isShown: false,
        });
    };
    OptionConfirmationDialog.prototype.onDismissed = function () {
        this.props.onClose();
    };
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onSave", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDiscard", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDismiss", null);
    tslib_1.__decorate([
        Utilities_1.autobind
    ], OptionConfirmationDialog.prototype, "onDismissed", null);
    OptionConfirmationDialog = tslib_1.__decorate([
        mobx_react_1.observer
    ], OptionConfirmationDialog);
    return OptionConfirmationDialog;
}(React.Component));
var confirmOptionContainer;
function confirmOptionNavigation(props) {
    if (!confirmOptionContainer) {
        confirmOptionContainer = document.createElement('div');
        document.body.appendChild(confirmOptionContainer);
    }
    ReactDOM.render(React.createElement(OptionConfirmationDialog, tslib_1.__assign({}, props, { onClose: function () {
            ReactDOM.unmountComponentAtNode(confirmOptionContainer);
        } })), confirmOptionContainer);
}
exports.default = confirmOptionNavigation;
//# sourceMappingURL=OptionConfirmationDialog.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/owa-options-core/lib/components/OptionConfirmationDialog.js
// module id = 1833
// module chunks = 2 39 105 108